import { Grid2 as Grid, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import Price from "./Price";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { removeItemFromOrder } from "@/features/order/slice";
import { getOrderItemPrice, getOrderDetails } from "@/utils/order";
import { OrderItem as OrderItemType, Content } from "@/types";
import { useMemo, useState } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { Delete02Icon, MoreVerticalIcon } from "@hugeicons/core-free-icons";
import { getThumbnailImage } from "@/utils/media";
import { setSelectedMenuItem } from "@/store/uiSlice";
import { useNavigate } from "react-router-dom";

interface Props extends OrderItemType {
  canEdit?: boolean;
  variant?: 'compact' | 'detailed' | 'expanded';
  onClose?: () => void;
}

const OrderItem = (dish: Props) => {
  const navigate = useNavigate();
  const { id, title, quantity, canEdit, variant } = dish;
  const dispatch = useAppDispatch();
  const organizationId = useAppSelector((store) => store.ui.activeOrganization)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    dispatch(removeItemFromOrder({ organizationId, itemId: id }));
    handleMenuClose();
  };

  const handleEdit = () => {
    handleMenuClose();
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("itemId", String(dish.id));
    navigate(`${location.pathname}?${searchParams.toString()}`);

    dispatch(setSelectedMenuItem(dish as unknown as Content));
  };

  const dishImage = useMemo(() => getThumbnailImage({
    file: dish.images || [],
    organizationId,
  }), [dish.images, organizationId])

  if (variant === 'expanded') {
    return (
      <Stack direction="row" alignItems="start" spacing={2}>
        <img src={dishImage} alt={title} width={50} height={50} style={{ borderRadius: "8px" }} />
        <Stack flex={1}>
          <Typography variant="body1">{title}</Typography>
          <Typography variant="body1" fontWeight={"medium"}>{quantity} x <Price currency="NIO">{getOrderItemPrice(dish as OrderItemType, true)}</Price></Typography>
        </Stack>
        <IconButton size="small" onClick={handleMenuOpen}>
          <HugeiconsIcon icon={MoreVerticalIcon} />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {/* <MenuItem dense onClick={handleEdit}>Editar</MenuItem> */}
          <MenuItem dense onClick={handleDelete}>Eliminar</MenuItem>
        </Menu>
      </Stack>
    )
  }

  return (
    <Grid container sx={{ alignItems: "center" }}>
      <Grid size={{ xs: 1 }}>
        <Typography variant="h4" fontSize={"18px"}>
          {quantity}
        </Typography>
      </Grid>
      <Grid size={{ xs: 11 }}>
        <Stack direction="row" alignItems="center" spacing={2} justifyContent={"space-between"}>
          <Stack>
            <Typography variant="h4" fontSize={"18px"}>
              {title}
            </Typography>
            <Typography variant="caption" fontSize={"14px"} color="textSecondary">
              {getOrderDetails(dish as OrderItemType)}
            </Typography>
          </Stack>

          <Stack spacing={1} direction="row" alignItems="center" justifyContent={"space-between"}>
            <Typography variant="h4" fontSize={"18px"}>
              <Price currency="NIO">{getOrderItemPrice(dish as OrderItemType)}</Price>
            </Typography>

            {canEdit ? (
              <IconButton edge="end" size="medium" aria-label="delete" onClick={() => dispatch(removeItemFromOrder({ organizationId, itemId: id }))}>
                <HugeiconsIcon icon={Delete02Icon} />
              </IconButton>
            ) : null}
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default OrderItem;
